function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCompanyNec = function SvgCompanyNec(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 302 81.993"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1414a0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h6.23c1.425 0 3.105-1.331 3.854-2.063l10.93-12.119V0h3.713v-19.349h-6.5c-1.158.039-2.295.277-3.62 1.579L3.695-5.629v-13.72H0V0Z",
    transform: "matrix(3.8755 0 0 -3.8755 1 3.458)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1414a0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c-4.447-.607-8.946-.667-13.454-.288-2.639.233-5.224.776-7.593 2.013-2.991 1.55-3.944 5.034-3.904 8.192.033 2.915.9 6.027 3.501 7.722 1.705 1.119 3.526 1.486 5.461 1.837 5.282.931 10.574.721 15.727.156v-2.76c-6.077 1.181-12.496.887-14.677-1.905-1.363-1.737-1.557-3.465-1.557-4.92 0-2.622.897-6.6 6.225-7.373 3.476-.51 6.917-.123 10.271.488V0Z",
    transform: "matrix(3.8755 0 0 -3.8755 301 78.957)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1414a0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c.526-.005 8.901-.044 11.776 0v-2.891C5.985-3.114.421-3.211-5.429-2.968c-4.964.205-5.819 2.701-5.915 5.099v14.341h22.843v-2.755H-3.279V8.791H10.19V6.102H-3.279c0-1.455.048-3.105.062-3.402C-3.138.824-2.268.134 0 0",
    transform: "matrix(3.8755 0 0 -3.8755 153.519 67.294)"
  }));
};
export default SvgCompanyNec;